var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 19v-2h10v2H2zm0-5v-2h5v2H2zm0-5V7h5v2H2zm18.6 10l-3.85-3.85c-.4.283-.838.496-1.313.637A5.004 5.004 0 0114 16c-1.383 0-2.563-.488-3.537-1.463C9.488 13.563 9 12.383 9 11s.488-2.563 1.463-3.537C11.438 6.487 12.617 6 14 6s2.563.487 3.538 1.463C18.512 8.437 19 9.617 19 11c0 .483-.07.963-.212 1.438a4.462 4.462 0 01-.638 1.312L22 17.6 20.6 19zM14 14c.833 0 1.542-.292 2.125-.875A2.893 2.893 0 0017 11c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0014 8c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0011 11c0 .833.292 1.542.875 2.125A2.893 2.893 0 0014 14z",
    fill: "#606E7B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageSearch);
export default __webpack_public_path__ + "static/media/manage_search.ceec4db105fa08915048b7caf4514332.svg";
export { ForwardRef as ReactComponent };